export default "__VITE_ASSET__2dd02e36__"